import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";


import MarathiFontUrl from "../fonts/NotoSansDevanagari-Regular.ttf"; 

// ============================================================================
// 0. CONSTANTS & DEFAULT EXPORT
// ============================================================================

const SmartifyConstants = {
    AllowPartylogoPrint: false,
    AllowExcelReports: false,
    AllowSlipPrinting: false,
    AllowUserSettings: false,
    AllowPdfReports: false,
    AllowCasteEditing: false,
    ShowVoterImage: false,
    DownloadData: false,
    PrintDetails: false,
    ShareDetails: false,
    ShareCandidateDetails: false,
    BoothManagement: false,
    FetchedCoordinates: false // Managed via localStorage logic below
};

export default SmartifyConstants;

// ============================================================================
// 1. HARDCODED DEFAULTS (Absolute Fallback)
// ============================================================================
const HARDCODED_ELEMENTS = [
    { id: "header_img", type: "image", x: 10, y: 5, w: 380, h: 75, src: "https://placehold.co/380x75/orange/white?text=ELECTION+SYMBOL&font=merriweather" },
    { id: "separator_line", type: "line", x: 10, y: 85, w: 380, h: 2, color: "#000000" },
    { id: "val_panel", type: "text", x: 11, y: 100, fontSize: 13, isBold: true, text: "Panel: 12" },
    { id: "val_booth_num", type: "text", x: 110, y: 100, fontSize: 13, isBold: true, text: "Booth: 45" },
    { id: "val_voter_num", type: "text", x: 210, y: 100, fontSize: 13, isBold: true, text: "Voter: 123" },
    { id: "val_card_no", type: "text", x: 310, y: 100, fontSize: 13, isBold: true, text: "GKG1234567" },
    { id: "val_assembly_info", type: "text", x: 310, y: 120, fontSize: 11, isBold: false, text: "141/23/890" },
    { id: "val_name_mr", type: "text", x: 10, y: 120, fontSize: 16, isBold: true, text: "नाव: रमेश सुरेश पाटील" },
    { id: "val_name_en", type: "text", x: 11, y: 146, fontSize: 12, isBold: true, text: "Name: Ramesh Suresh Patil" },
    { id: "val_age_sex", type: "text", x: 12, y: 170, fontSize: 11, isBold: false, text: "Age/Sex: 45/Male" },
    { id: "val_address", type: "text", x: 13, y: 190, fontSize: 11, isBold: false, text: "पत्ता: घर नं 101, शिवाजी नगर..." },
    { id: "val_booth_details", type: "text", x: 12, y: 210, fontSize: 11, isBold: false, text: "Booth: Z.P School No 5, Room 2" },
    { id: "footer_credit", type: 'text', x: 126, y: 229, fontSize: 9, isBold: true, text: 'Issued By: [User ID] - Smart Search', color: '#666666' }
];

const HARDCODED_PAGE_CONFIG = {
    marginTop: 16,
    marginLeft: 6,
    marginRight: 12,
    gapX: 17,
    gapY: 26,
    cardsPerPage: 8
};

// ============================================================================
// 2. DATA FETCHING LOGIC (Cache -> Server -> Hardcoded)
// ============================================================================
// ============================================================================
// 2. DATA FETCHING LOGIC (Server -> Cache -> Hardcoded)
// ============================================================================
// ============================================================================
// 2. DATA FETCHING LOGIC (Runtime Flag -> Cache -> Server -> Hardcoded)
// ============================================================================
const getActiveLayout = async () => {
    let allLayouts = [];
    const targetUrl = 'http://anuplights.in/uploads/json/slip_settings.json';
    let fetchedFromServer = false;



    // ---------------------------------------------------------
    // STEP 0: CHECK RUNTIME CONSTANT (Session Memory)
    // ---------------------------------------------------------
    // If true, we assume data was already fetched this session and is valid in LocalStorage.
    
    
    if (SmartifyConstants.FetchedCoordinates === true) {
        
        console.log("⚡ [SmartSearch] Runtime flag is TRUE. Skipping Server...");
        
        const cachedData = localStorage.getItem("CACHED_LAYOUT_DATA");
        if (cachedData) {
            try {


                const parsed = JSON.parse(cachedData);
                console.log("✅ [SmartSearch] Retrieving data from Cache.");
                console.log(parsed);
                return parsed; // <--- RETURN IMMEDIATELY
            } catch (err) {
                console.warn("❌ [SmartSearch] Cache Corrupted.", err);
            }
        } else {
            console.warn("⚠️ [SmartSearch] Flag is TRUE but Cache is empty. Forced to fetch.");
        }
    }

    // ---------------------------------------------------------
    // STEP 1: ATTEMPT SERVER FETCH (If Flag was False)
    // ---------------------------------------------------------
    try {
        console.log("⏳ [SmartSearch] Fetching Layouts from Server...");
        const res = await fetch(targetUrl + '?t=' + Date.now(), { method: 'POST', cache: "no-store" });
        
        if (res.ok) {
            const json = await res.json();
            if (Array.isArray(json) && json.length > 0) {
                allLayouts = json;
                fetchedFromServer = true;
                console.log("✅ [SmartSearch] Fetch Success. Items found:", json.length);
            }
        }
    } catch (e) {
        console.warn("⚠️ [SmartSearch] Direct fetch failed. Trying Proxy...", e);
        try {
            const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(targetUrl)}&t=${Date.now()}`;
            const res = await fetch(proxyUrl);
            if (res.ok) {
                const json = await res.json();
                if (Array.isArray(json) && json.length > 0) {
                    allLayouts = json;
                    fetchedFromServer = true;
                }
            }
        } catch (proxyErr) {
            console.warn("❌ [SmartSearch] Proxy fetch failed.", proxyErr);
        }
    }

    // ---------------------------------------------------------
    // STEP 2: PROCESS SERVER DATA (AND UPDATE CONSTANT)
    // ---------------------------------------------------------
    if (fetchedFromServer && allLayouts.length > 0) {
        const userId = localStorage.getItem("UserId");
        let target = allLayouts.find(l => l.layoutName && String(l.layoutName).trim() === String(userId).trim());
        
        if (!target) {
            target = allLayouts.find(l => l.layoutName === "Default 8 Ups");
        }

        if (target) {
            console.log("💾 [SmartSearch] Updating Runtime Flag & Data Cache...");
            
            // 1. Save DATA to storage (so Step 0 can read it next time)
            localStorage.setItem("CACHED_LAYOUT_DATA", JSON.stringify(target));
            
            // 2. 🔥 UPDATE THE RUNTIME CONSTANT ONLY (Not LocalStorage)
            SmartifyConstants.FetchedCoordinates = true; 

            return target;
        }
    }

    // ---------------------------------------------------------
    // STEP 3: FALLBACK
    // ---------------------------------------------------------
    console.warn("⚠️ [SmartSearch] Fetch failed. Checking Cache as last resort...");
    const lastResortCache = localStorage.getItem("CACHED_LAYOUT_DATA");
    if(lastResortCache) return JSON.parse(lastResortCache);

    return null; 
};

// ============================================================================
// HELPER: LOAD FONT
// ============================================================================
const loadFontForDoc = async (doc) => {
  try {
    const response = await fetch(MarathiFontUrl);
    if (!response.ok) throw new Error("Font fetch failed");
    
    const buffer = await response.arrayBuffer();
    let binary = "";
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64 = window.btoa(binary);

    doc.addFileToVFS("Marathi.ttf", base64);
    doc.addFont("Marathi.ttf", "Marathi", "normal");
    doc.addFont("Marathi.ttf", "Marathi", "bold"); 
    doc.setFont("Marathi", "normal");
    return true;
  } catch (err) {
    console.error("❌ Font load failed:", err);
    return false;
  }
};

// ============================================================================
// HELPER: LOAD IMAGE
// ============================================================================
const loadImage = (originalUrl) => {
  return new Promise((resolve) => {
    if (!originalUrl) {
        console.warn("❌ No Image URL provided");
        return resolve(null);
    }

    const isLocal = originalUrl.startsWith("blob:") || originalUrl.startsWith("data:");
    const img = new Image();
    img.crossOrigin = "Anonymous"; 

    if (isLocal) {
      img.src = originalUrl;
    } else {
      const cleanUrl = originalUrl.replace(/^https?:\/\//, "");
      img.src = `https://wsrv.nl/?url=${cleanUrl}&output=png`;
    }

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      try {
        resolve({ 
            dataUrl: canvas.toDataURL("image/png"), 
            width: img.width, 
            height: img.height 
        });
      } catch (e) {
        console.error("❌ Canvas taint error", e);
        resolve(null);
      }
    };

    img.onerror = (e) => {
        console.error("❌ Image failed to load:", originalUrl, e);
        resolve(null);
    };
  });
};

// ============================================================================
// FUNCTION 1: GENERATE A4 SLIPS
// ============================================================================
export const generateA4Slips = async ({ 
    data = [], 
    fileName, 
    slipImageUrl, 
    candidateName, 
    allowLogoPrint 
}) => {
    console.group("🖨️ [SmartSearch] generateA4Slips Process");
    console.log("🔹 Starting Slip Generation...");

    if (!Array.isArray(data) || data.length === 0) {
        console.warn("⚠️ [SmartSearch] No rows passed to generateA4Slips");
        console.groupEnd();
        alert("No data to print");
        return;
    }

    // 1. GET LAYOUT DATA (Cache -> Server -> Hardcoded)
    const bestLayout = await getActiveLayout();

    let activeElements = HARDCODED_ELEMENTS;
    let activePageConfig = HARDCODED_PAGE_CONFIG;

    if (bestLayout) {
        if (bestLayout.elements) {
            console.log("✅ Using Dynamic Elements from Layout");
            activeElements = bestLayout.elements;
        }
        if (bestLayout.pageConfig) {
            console.log("✅ Using Dynamic PageConfig from Layout");
            activePageConfig = bestLayout.pageConfig;
        }
    } else {
        console.log("⚠️ Using Hardcoded Defaults");
    }

    // 2. MAP CONFIG FOR EASY ACCESS
    let configMap = {};
    activeElements.forEach(el => configMap[el.id] = el);

    // 3. EXTRACT PAGE CONFIG
    const PAGE_WIDTH = 210;
    const PAGE_HEIGHT = 297;

    const MARGIN_LEFT   = Number(activePageConfig.marginLeft) || 6; 
    const MARGIN_TOP    = Number(activePageConfig.marginTop)  || 16; 
    const MARGIN_RIGHT  = Number(activePageConfig.marginRight) || 12; 
    const MARGIN_BOTTOM = 12; 
    
    const GAP_X         = Number(activePageConfig.gapX) || 17; 
    const GAP_Y         = Number(activePageConfig.gapY) || 26; 

    const CARDS_PER_PAGE = Number(activePageConfig.cardsPerPage) || 8;
    const COLS = 2; 
    const ROWS = Math.ceil(CARDS_PER_PAGE / COLS);

    const AVAILABLE_WIDTH = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT - (GAP_X * (COLS - 1));
    const CARD_WIDTH = AVAILABLE_WIDTH / COLS; 
    const AVAILABLE_HEIGHT = PAGE_HEIGHT - MARGIN_TOP - MARGIN_BOTTOM - (GAP_Y * (ROWS - 1));
    const CARD_HEIGHT = AVAILABLE_HEIGHT / ROWS; 

    const startX = MARGIN_LEFT; 
    const startY = MARGIN_TOP; 
    
    const SCALE = CARD_WIDTH / 400;
    const CONTENT_WIDTH = CARD_WIDTH - 4; 
    const TOP_OFFSET = 22; 

    // ------------------------------------------------------------------
    // 📐 DEBUG: PRINT RAW LAYOUT & COORDINATE CONFIGURATION
    // ------------------------------------------------------------------
    const layoutSource = bestLayout ? "DYNAMIC (Server/Cache)" : "HARDCODED DEFAULTS";
    const layoutName = bestLayout?.layoutName || "N/A (Using Defaults)";

    console.group("🏗️ [SmartSearch] LAYOUT ENGINE DIAGNOSTICS");
    
    console.log(`%c SOURCE: ${layoutSource}`, "color: green; font-weight: bold; font-size: 14px;");
    console.log(`%c LAYOUT NAME: ${layoutName}`, "color: blue; font-weight: bold;");

    console.log("📏 1. PAGE GEOMETRY (mm):", {
        "Page Size": { w: PAGE_WIDTH, h: PAGE_HEIGHT },
        "Margins": { Top: MARGIN_TOP, Right: MARGIN_RIGHT, Bottom: MARGIN_BOTTOM, Left: MARGIN_LEFT },
        "Gaps": { X: GAP_X, Y: GAP_Y },
        "Grid": { CardsPerPage: CARDS_PER_PAGE, Rows: ROWS, Cols: COLS }
    });

    console.log("📐 2. CALCULATED CARD DIMENSIONS:", {
        "Available Area": { w: AVAILABLE_WIDTH, h: AVAILABLE_HEIGHT },
        "Single Card": { w: CARD_WIDTH, h: CARD_HEIGHT },
        "Start Offset": { x: startX, y: startY },
        "Scale Factor": SCALE,
        "Content Width": CONTENT_WIDTH,
        "Top Offset": TOP_OFFSET
    });

    console.log("🧩 3. ELEMENT POSITIONS (The Raw Map):");
    console.table(activeElements.map(el => ({
        ID: el.id,
        Type: el.type,
        X_Raw: el.x,
        Y_Raw: el.y,
        X_Calc: startX + (el.x * SCALE),  // Preview of calculated X on first card
        Y_Calc: startY + (el.y * SCALE),  // Preview of calculated Y on first card
        Font: el.fontSize || "N/A"
    })));

    console.groupEnd();
    // ------------------------------------------------------------------

    // Helper: Get Coordinates
    const getCustomPos = (id, baseX, baseY) => {
        const config = configMap[id];
        if (config && typeof config.x === 'number') {
            const fontSizeOffset = (config.fontSize || 12) * 0.3 * SCALE;
            return {
                x: baseX + (config.x * SCALE),
                y: baseY + (config.y * SCALE) + fontSizeOffset,
                found: true
            };
        }
        return { found: false };
    };

    // const isPrePrinted = window.confirm("Do you want it on pre-printed paper?\n\nOK = Yes (No Image/Border, Top Margin 32mm)\nCancel = No (Standard print with Image/Border)");
    const isPrePrinted =true;
    
    const ACTUAL_TOP_OFFSET = isPrePrinted ? 32 : TOP_OFFSET;
    const ACTUAL_CONTENT_WIDTH = isPrePrinted ? 80 : CONTENT_WIDTH;

    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    await loadFontForDoc(doc);
  
    let imgObj = null;
    const shouldPrintImage = !isPrePrinted && (allowLogoPrint === true || allowLogoPrint === 1);
    if (shouldPrintImage) {
        console.log("🖼️ Loading Slip Image...");
        imgObj = await loadImage(slipImageUrl);
    }

    const uid = localStorage.getItem("UserId") || "";

    data.forEach((voter, index) => {
        const raw = voter.raw || {};
        
        if (index > 0 && index % CARDS_PER_PAGE === 0) doc.addPage();

        const posIndex = index % CARDS_PER_PAGE;
        const col = posIndex % COLS; 
        const row = Math.floor(posIndex / COLS); 

        const x = startX + (col * (CARD_WIDTH + GAP_X));
        const y = startY + (row * (CARD_HEIGHT + GAP_Y));
        const centerX = x + (CARD_WIDTH / 2);
        const padL = x + 2.5; 
        const padR = x + CARD_WIDTH - 2.5;

        // --- DRAW GRAPHICS ---
        if (!isPrePrinted) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.3);
            doc.rect(x, y, CARD_WIDTH, CARD_HEIGHT);

            if (imgObj && imgObj.dataUrl) {
                const imgConf = configMap['header_img'];
                let drawX, drawY, drawW, drawH;

                if (imgConf) {
                    const boxW = imgConf.w * SCALE;
                    const boxH = imgConf.h * SCALE;
                    const imgRatio = imgObj.width / imgObj.height;
                    const boxRatio = boxW / boxH;

                    if (imgRatio > boxRatio) { drawW = boxW; drawH = boxW / imgRatio; } 
                    else { drawH = boxH; drawW = boxH * imgRatio; }

                    drawX = x + (imgConf.x * SCALE) + (boxW - drawW) / 2;
                    drawY = y + (imgConf.y * SCALE) + (boxH - drawH) / 2;
                } else {
                    const boxW = CARD_WIDTH - 2; 
                    const boxH = 20; 
                    const imgRatio = imgObj.width / imgObj.height;
                    const boxRatio = boxW / boxH;
                    if (imgRatio > boxRatio) { drawW = boxW; drawH = boxW / imgRatio; } 
                    else { drawH = boxH; drawW = boxH * imgRatio; }
                    drawX = x + 1 + (boxW - drawW) / 2;
                    drawY = y + 1 + (boxH - drawH) / 2;
                }
                doc.addImage(imgObj.dataUrl, "PNG", drawX, drawY, drawW, drawH);
            } 

            const lineConf = configMap['separator_line'];
            doc.setDrawColor(0); 
            if (lineConf) {
                 const PADDING_OFFSET = 4 * SCALE; 
                 doc.setLineWidth(lineConf.h * SCALE); 
                 const lineX = x + (lineConf.x * SCALE);
                 const lineY = y + (lineConf.y * SCALE) + PADDING_OFFSET; 
                 const lineW = lineConf.w * SCALE; 
                 doc.line(lineX, lineY, lineX + lineW, lineY);
            } else {
                 const lineY = y + TOP_OFFSET;
                 doc.setLineWidth(0.5);
                 doc.line(x, lineY, x + CARD_WIDTH, lineY);
            }
        }

        // --- TEXT CONTENT ---
        let cursorY = isPrePrinted ? (y + ACTUAL_TOP_OFFSET) : (y + TOP_OFFSET + 4);
        doc.setTextColor(0);

        // Header
        cursorY += 4.0; 
        doc.setFontSize(9);
        doc.setFont("Marathi", "bold");
        const panelNo = voter.PanelNumber || raw.PanelNumber || "-";
        const voterNo = voter.VoterNumber || raw.VoterNumber || "-";
        const boothNo = voter.Booth || raw.Booth || voter.BoothNumber || raw.BoothNumber || "-";
        const cardVal = voter.CardNo || raw.CardNo || voter.cardno || "-";

        const pPos = getCustomPos('val_panel', x, y);
        const bPos = getCustomPos('val_booth_num', x, y);
        const vPos = getCustomPos('val_voter_num', x, y);
        const cPos = getCustomPos('val_card_no', x, y);

        if (pPos.found || bPos.found || vPos.found) {
            if(pPos.found) doc.text(`Panel: ${panelNo}`, pPos.x, pPos.y);
            else doc.text(`Panel: ${panelNo}`, padL, cursorY);

            if(bPos.found) doc.text(`Booth: ${boothNo}`, bPos.x, bPos.y);
            
            if(vPos.found) doc.text(`Voter: ${voterNo}`, vPos.x, vPos.y);
        } else {
            doc.text(`Panel: ${panelNo}   Booth: ${boothNo}   Voter: ${voterNo}`, padL, cursorY);
        }

        if(cPos.found) doc.text(cardVal, cPos.x, cPos.y);
        else doc.text(cardVal, padR, cursorY, { align: "right" });

        // Assembly
        cursorY += 3.8; 
        doc.setFontSize(8);
        doc.setFont("Marathi", "normal");
        const ac = voter.constno || raw.constno || "-";
        const part = voter.yadibhag || raw.yadibhag || "-";
        const sr = voter.vno || raw.vno || "-";
        let assemblyStr = `${ac}/${part}/${sr}`;
        if (ac === "-" && part === "-" && (voter.Assembly || raw.Assembly)) assemblyStr = voter.Assembly || raw.Assembly;
        
        const aPos = getCustomPos('val_assembly_info', x, y);
        if(aPos.found) doc.text(assemblyStr, aPos.x, aPos.y);
        else doc.text(assemblyStr, padR, cursorY, { align: "right" });

        // Name Marathi
        cursorY += 2.1; 
        doc.setFontSize(10); 
        doc.setFont("Marathi", "bold"); 
        const marSurname = voter.surname_marathi || voter.Surname || raw.surname_marathi || "";
        const marName = voter.name_marathi || voter.Name || raw.name_marathi || "";
        const marRelative = voter.relative_marathi || voter.Relative || raw.relative_marathi || "";
        let marFullName = `${marSurname} ${marName} ${marRelative}`.trim();
        if (!marFullName) marFullName = "-";
        const marLines = doc.splitTextToSize(`नाव: ${marFullName}`, ACTUAL_CONTENT_WIDTH);
        
        const mPos = getCustomPos('val_name_mr', x, y);
        if(mPos.found) doc.text(marLines, mPos.x, mPos.y);
        else doc.text(marLines, padL, cursorY);
        cursorY += (marLines.length * 4.0) - 4.0; 

        // Name English
        cursorY += 4.0; 
        doc.setFontSize(8.5); 
        doc.setFont("Marathi", "bold");
        const nameEng = `${voter.esurname || raw.esurname || ""} ${voter.name_english || raw.name_english || ""} ${voter.relative_english || raw.relative_english || ""}`;
        const engLines = doc.splitTextToSize(`Name: ${nameEng.trim()}`, ACTUAL_CONTENT_WIDTH);
        
        const ePos = getCustomPos('val_name_en', x, y);
        if(ePos.found) doc.text(engLines, ePos.x, ePos.y);
        else doc.text(engLines, padL, cursorY);
        cursorY += (engLines.length * 3.5) - 3.5; 

        // Age / Sex
        cursorY += 4.0; 
        doc.setFontSize(8);
        doc.setFont("Marathi", "normal");
        const age = voter.age || raw.age || voter.Age || raw.Age || "-";
        const sex = voter.sex || raw.sex || voter.Sex || raw.Sex || "-";
        
        const asPos = getCustomPos('val_age_sex', x, y);
        if(asPos.found) doc.text(`Age/Sex: ${age}/${sex}`, asPos.x, asPos.y);
        else doc.text(`Age/Sex: ${age}/${sex}`, padL, cursorY);
        
        // Address
        cursorY += 3.5; 
        const addressText = `Add: ${voter.address_marathi || voter.address_m || voter.address || raw.address || "-"}`;
        const addrLines = doc.splitTextToSize(addressText, ACTUAL_CONTENT_WIDTH);

        const adPos = getCustomPos('val_address', x, y);
        if(adPos.found) doc.text(addrLines, adPos.x, adPos.y);
        else doc.text(addrLines, padL, cursorY);
        
        // Dynamic Height Calculation for Address
        const addressHeight = addrLines.length * 3.2; 
        cursorY += addressHeight;

        // Booth
        cursorY += 1.0; 
        const bAddr = voter.BoothAddress1 || raw.BoothAddress1 || voter.FinalBooth || voter.booth_address || "";
        const finalBoothText = (bAddr && bAddr.trim() !== "" && bAddr !== "N/A") ? `Booth: ${bAddr}` : "Booth: Awaiting government approval";
        const boothLines = doc.splitTextToSize(finalBoothText, ACTUAL_CONTENT_WIDTH);
        
        const bdPos = getCustomPos('val_booth_details', x, y);
        if(bdPos.found) doc.text(boothLines, bdPos.x, bdPos.y);
        else doc.text(boothLines, padL, cursorY);
        
        const boothHeight = boothLines.length * 3.2;
        cursorY += boothHeight;

        // Footer
        const footerY = cursorY + 2.0; 
        doc.setFontSize(6); 
        doc.setFont("Marathi", "bold");
        doc.setTextColor(80); 
        const cName = voter.services_by || "Smart Search - 9767728530";

        const fPos = getCustomPos('footer_credit', x, y);
        if(fPos.found) doc.text(`${uid} ${cName}`, fPos.x, fPos.y);
        else doc.text(`${uid} ${cName}`, centerX, footerY, { align: "center" });
    });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.setTextColor(0);
        doc.text(`${i} | ${totalPages}`, PAGE_WIDTH / 2, PAGE_HEIGHT - 5, { align: "center" });
    }

    doc.autoPrint(); 
    // 🔥 UPDATED: OPEN IN WINDOW ABOVE (NO NEW TAB)
    window.open(doc.output('bloburl'), '_blank', 'width=900,height=800');
    console.log("✅ [SmartSearch] PDF Generation Complete.");
    console.groupEnd();
};

// ============================================================================
// FUNCTION 2: GENERATE LIST PDF (USING SAME LAYOUT LOGIC)
// ============================================================================
export const generatePdf = async ({ 
    titleLine1, 
    titleLine2, 
    fileName, 
    columns = [], 
    data = [] 
}) => {
    console.group("📄 [SmartSearch] generatePdf Process (List)");
    console.log("🔹 Starting PDF List Generation...");

    // 1. GET LAYOUT DATA (Cache -> Server -> Hardcoded)
    const bestLayout = await getActiveLayout();

    let activePageConfig = HARDCODED_PAGE_CONFIG;

    if (bestLayout && bestLayout.pageConfig) {
        activePageConfig = bestLayout.pageConfig;
        console.log("✅ Using Dynamic PageConfig");
    } else {
        console.log("⚠️ Using Hardcoded PageConfig");
    }

    // 2. EXTRACT MARGINS 
    const marginLeft = Number(activePageConfig.marginLeft) || 6; 
    const marginTop = Number(activePageConfig.marginTop) || 16;
    const marginRight = Number(activePageConfig.marginRight) || 12;

    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    
    await loadFontForDoc(doc); 
    
    const tableHeaders = columns.map((c) => c.label);
    const tableBody = data.map((row, i) => [ i + 1, ...columns.map((c) => row[c.key] || "") ]);
    const finalHeaders = [["SrNo", ...tableHeaders]];

    const fontName = "Marathi"; 
    doc.setFont(fontName); 
    
    // 3. DRAW TITLES
    doc.setFontSize(14);
    doc.setTextColor(0);
    doc.text(titleLine1 || "Voter List", marginLeft, marginTop);

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(titleLine2 || "", marginLeft, marginTop + 6);

    // 4. DRAW TABLE
    autoTable(doc, {
        startY: marginTop + 12, 
        margin: { left: marginLeft, right: marginRight, top: marginTop }, 
        head: finalHeaders,
        body: tableBody,
        styles: { 
            font: fontName, 
            fontStyle: "normal", 
            fontSize: 9, 
            cellPadding: 2 
        },
        headStyles: { 
            fillColor: [41, 128, 185], 
            textColor: 255, 
            fontStyle: "bold" 
        },
        columnStyles: { 0: { cellWidth: 12 } },
        didDrawPage: (data) => {
            const pageCount = doc.internal.getNumberOfPages();
            doc.setFontSize(8);
            doc.text(`Page ${pageCount}`, marginLeft, doc.internal.pageSize.height - 10);
        },
    });

  doc.autoPrint(); 
  // 🔥 UPDATED: OPEN IN WINDOW ABOVE (NO NEW TAB)
  window.open(doc.output('bloburl'), '_blank', 'width=900,height=800');
  console.log("✅ [SmartSearch] PDF List Complete.");
  console.groupEnd();
};